.back-button-link{text-decoration:none;display:inline-block}.back-button-link *{vertical-align:middle}.back-button-link:hover{font-variation-settings:"FILL" 1}.back-button-icon{transform:rotate(90deg)}.back-button-link{text-align:center}
/*# sourceMappingURL=back-button.component-5OS2CU2H.css.map */
